import { render } from "./KnowUniv.vue?vue&type=template&id=e90e9e48"
import script from "./KnowUniv.vue?vue&type=script&lang=js"
export * from "./KnowUniv.vue?vue&type=script&lang=js"
script.render = render

export default script